import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsOfService = () => {
  return (
    <div className="w3-container w3-margin">
      <Helmet>
        <title>Terms of Service - Kayannou</title>
        <meta name="description" content="Terms of Service for Kayannou unit conversion tools. Read our terms and conditions for using our services." />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="w3-card-4 w3-white w3-margin">
        <div className="w3-container w3-orange">
          <h1>Terms of Service</h1>
        </div>

        <div className="w3-container w3-padding">
          <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>

          <h2>Acceptance of Terms</h2>
          <p>
            By accessing and using Kayannou's unit conversion tools, you accept and agree to be bound
            by the terms and provision of this agreement.
          </p>

          <h2>Use License</h2>
          <p>
            Permission is granted to temporarily use Kayannou's conversion tools for personal,
            non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul>
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose or for any public display</li>
            <li>Attempt to reverse engineer any software contained on the website</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
          </ul>

          <h2>Disclaimer</h2>
          <p>
            The materials on Kayannou's website are provided on an 'as is' basis. Kayannou makes no warranties,
            expressed or implied, and hereby disclaim and negate all other warranties including without limitation,
            implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement
            of intellectual property or other violation of rights.
          </p>

          <h2>Accuracy of Conversions</h2>
          <p>
            While we strive to provide accurate conversion calculations, Kayannou does not warrant that the
            conversion results are error-free or complete. Users should verify important calculations independently.
          </p>

          <h2>Limitations</h2>
          <p>
            In no event shall Kayannou or its suppliers be liable for any damages (including, without limitation,
            damages for loss of data or profit, or due to business interruption) arising out of the use or inability
            to use the materials on Kayannou's website.
          </p>

          <h2>Privacy Policy</h2>
          <p>
            Your use of our service is also governed by our Privacy Policy. Please review our Privacy Policy,
            which also governs the Site and informs users of our data collection practices.
          </p>

          <h2>Advertising</h2>
          <p>
            Kayannou may display advertisements from third parties, including Google AdSense.
            We are not responsible for the content of these advertisements.
          </p>

          <h2>Modifications</h2>
          <p>
            Kayannou may revise these terms of service at any time without notice. By using this website,
            you are agreeing to be bound by the then current version of these terms of service.
          </p>

          <h2>Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in accordance with the laws and
            you irrevocably submit to the exclusive jurisdiction of the courts in that state or location.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
